// The chosen site lives in the login session, so it's shared by every tab:
// switching site in one tab moves the others on their next request, while they
// still show the old site. Each page announces its site to the other tabs; a
// tab showing a different one says so and offers a reload.
//
//   <html data-site-id="11">, and the site picker's name carries data-site-name.

const CHANNEL = 'ma-admin-site';

export default () => ({
  switchedTo: '',

  init() {
    const siteId = document.documentElement.dataset.siteId;

    if (!siteId || !('BroadcastChannel' in window)) {
      return;
    }

    const name = document.querySelector('[data-site-name]')?.textContent.trim() ?? '';
    const channel = new BroadcastChannel(CHANNEL);

    channel.addEventListener('message', ({ data }) => {
      this.switchedTo = data?.siteId && data.siteId !== siteId ? data.name || 'another site' : '';
    });

    channel.postMessage({ siteId, name });
  },

  reload() {
    window.location.reload();
  },
});
